import {Injectable} from '@angular/core';
import {BaseModelService} from '../../base-model.service';

@Injectable({
  providedIn: 'root'
})
export class MachinesCheckpointModelService extends BaseModelService {

  tableName = 'yu_v3_machines_checkpoint';

}
